/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FileManagementAddFileUploadResponse } from "./FileManagementAddFileUploadResponse";

export type FileManagementAddFileUploadResponseApiRespoonse = {
  data?: FileManagementAddFileUploadResponse;
  status?: FileManagementAddFileUploadResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FileManagementAddFileUploadResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
